import { render } from "./TextEditor.vue?vue&type=template&id=0894fe8b&scoped=true"
import script from "./TextEditor.vue?vue&type=script&lang=js"
export * from "./TextEditor.vue?vue&type=script&lang=js"

import "./TextEditor.vue?vue&type=style&index=0&id=0894fe8b&scoped=true&lang=scss"
import "./TextEditor.vue?vue&type=style&index=1&id=0894fe8b&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0894fe8b"]])

export default __exports__